module.exports = __webpack_public_path__ + "img/peach-picking princess.af685dba.png";